module.exports = __webpack_public_path__ + "img/sample_bg_04.8aef7ecb.jpg";